import { render, staticRenderFns } from "./grossing-touch-portion-sidepanel.vue?vue&type=template&id=fb280cf0&"
import script from "./grossing-touch-portion-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-portion-sidepanel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports